import { render, staticRenderFns } from "./LeaderList.vue?vue&type=template&id=4510dfba&scoped=true&"
import script from "./LeaderList.vue?vue&type=script&lang=js&"
export * from "./LeaderList.vue?vue&type=script&lang=js&"
import style0 from "./LeaderList.vue?vue&type=style&index=0&id=4510dfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4510dfba",
  null
  
)

export default component.exports